/**
 * Procedure Categories and Procedures for MD in Sports Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 3 & 12: "Psychomotor domain & Procedural skills")
 */
export const SPORTS_MEDICINE_PROCEDURES = {
  "Performance & Kinanthropometric Procedures": [
    "Kinanthropometric Body Composition Analysis, Somatotyping & Age Determination",
    "Exercise Physiology & Isokinetics Performance Testing",
    "Biomechanical Motion Analysis & Force Assessment of Athletes",
    "Sports Psychology Laboratory Evaluation & Stress Testing",
  ],
  "Field-Side & Rehabilitation Procedures": [
    "Design & Implementation of Sports Injury Prevention & Management Programs",
    "Field-Side Emergency Care & First Aid Procedures",
    "Functional Bandaging, Taping & Orthotic Aid Application",
    "Sports Physical Therapy & Rehabilitation Exercise Procedures",
  ],
};

export const SPORTS_MEDICINE_CATEGORIES = Object.keys(SPORTS_MEDICINE_PROCEDURES);

export const isMDInSportsMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("sports medicine") || d.includes("sports");
};

